"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordPage = exports.ForgotPasswordPageConfig = void 0;
const centered_card_1 = require("../components/centered.card/centered.card");
const forgot_password_1 = require("../modules/user/forgot.password");
const forgot_password_ctrl_1 = require("../modules/user/forgot.password.ctrl");
const page_1 = require("./page");
exports.ForgotPasswordPageConfig = {
    type: 'internal',
    name: page_1.IkePageName.forgotPassword,
    path: '/forgot-password',
    auth: { required: false },
    layout: { nav: false, banner: false },
};
class ForgotPasswordPage extends page_1.IkePage {
    constructor() {
        super(exports.ForgotPasswordPageConfig);
        const ctrl = new forgot_password_ctrl_1.ForgotPasswordCtrl();
        this.component = new forgot_password_1.ForgotPasswordComponent(ctrl);
    }
    get nodes() {
        return centered_card_1.CenteredCard.view(this.component.view());
    }
}
exports.ForgotPasswordPage = ForgotPasswordPage;
//# sourceMappingURL=forgot.password.page.js.map